// /reset-password?token=... (FR-039 to FR-042; P-AUTH-1). Works signed in or not.
import { ResetPasswordScreen } from "@/auth/links/ResetPasswordScreen";

export default function ResetPassword() {
  return <ResetPasswordScreen />;
}
